/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_Qc_ReviewInputs */



/**
* | output |
* | --- |
* | "QC & Review" |
*
* @param {Quicktools_Tab_Qc_ReviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_qc_review = /** @type {((inputs?: Quicktools_Tab_Qc_ReviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_Qc_ReviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("QC et revision")
	if (locale === "de") return /** @type {LocalizedString} */ ("Qualitätskontrolle und Überprüfung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controllo qualità e revisione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Контроль качества и проверка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Control de calidad y revisión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("质量控制与审核")
	if (locale === "ja") return /** @type {LocalizedString} */ ("QCとレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गुणवत्ता नियंत्रण और समीक्षा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Controle de Qualidade e Revisão")
	return /** @type {LocalizedString} */ ("QC & Review")
});